// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab_container__1q1S4","active":"Tab_active__FEw_s"};